/*
 * @Author: zyy
 * @Date: 2023-03-14 16:02:55
 * @LastEditors: zyy
 * @LastEditTime: 2023-03-14 16:05:38
 * @Description: default
 */
import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 订单列表
    statistics(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_dashboard/index', {
            params,

        })
    },
}